"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.prepareAxiosErrorDataInterceptor = void 0;
var failedAxiosUrl;

var prepareAxiosErrorDataInterceptor = function prepareAxiosErrorDataInterceptor(sentryEnabled) {
  return function (error) {
    if (sentryEnabled && error && error.isAxiosError) {
      failedAxiosUrl = error.config.url;
    }
  };
};

exports.prepareAxiosErrorDataInterceptor = prepareAxiosErrorDataInterceptor;

var pushAxiosDataToSentry = function pushAxiosDataToSentry(event) {
  if (failedAxiosUrl) {
    if (!event.extra) {
      event.extra = {};
    }

    event.fingerprint = [event.exception.values[0].value, failedAxiosUrl].filter(Boolean);
    event.extra.failedAxiosUrl = failedAxiosUrl;
    failedAxiosUrl = undefined;
  }

  return event;
};

var _default = pushAxiosDataToSentry;
exports.default = _default;